export interface GeneratePreviewsRequest {
  readonly force?: boolean;
  readonly theme_id?: string | null;
  // CR-112: optional subset of PREVIEW_SCREEN_KEYS used by the per-tile
  // regenerate flow. Requires `theme_id` when set; backend rejects
  // empty lists + unknown keys with 400.
  readonly screen_keys?: readonly string[];
}

export interface GeneratePreviewsResponse {
  readonly job_id: string;
  readonly total_themes: number;
  readonly new_assignments: number;
  readonly stale_themes: number;
  readonly request_ids: readonly string[];
}

export type JobStatus = "running" | "completed";

export interface JobStatusResponse {
  readonly job_id: string;
  readonly status: JobStatus | string;
  readonly total: number;
  readonly completed: number;
  readonly generating: number;
  readonly failed: number;
  readonly pending: number;
}

export interface AssignmentResponse {
  readonly theme_id: string;
  readonly tenant_code: string;
  readonly last_generated: string | null;
  readonly is_stale: boolean;
  // CR-110: backend now denormalises theme+category names onto each row.
  // Fields are optional on the TS side so the UI stays resilient during
  // rollout (old backend → old shape → table falls back to theme_id).
  readonly theme_name?: string;
  readonly category_name?: string;
  readonly category_id?: string;
}

export function isJobTerminal(
  job: Pick<JobStatusResponse, "status" | "completed" | "failed" | "total">,
): boolean {
  if (job.status === "completed") return true;
  if (job.total === 0) return true; // no-op job (no themes queued)
  return job.completed + job.failed >= job.total;
}
